<template>
    <div class="sd-wrap">
        <div class="flex items-center justify-between flex-wrap gap-2 mb-4">
            <div>
                <h6 class="font-semibold mb-1">Appareils serveurs (restaurant)</h6>
                <p class="text-[0.8rem] text-defaulttextcolor/70 mb-0">
                    Serveurs ayant pris service aujourd'hui. La liste est remise à zéro
                    chaque matin à 9h. Le nombre de serveurs est plafonné par la licence.
                </p>
            </div>
            <div class="flex items-center gap-2">
                <span class="badge bg-primary/10 text-primary text-[0.8rem]">
                    {{ used }} serveur(s) présent(s)
                </span>
                <button class="ti-btn ti-btn-primary-full ti-btn-sm" :disabled="loading" @click="charger">
                    <i class="ri-refresh-line" :class="{ 'animate-spin': loading }"></i>
                    <span>Actualiser</span>
                </button>
            </div>
        </div>

        <div v-if="loading && !loaded" class="text-center py-6 text-defaulttextcolor/60">
            <i class="ri-loader-4-line animate-spin text-2xl"></i>
            <p class="mb-0 mt-2">Chargement…</p>
        </div>

        <div v-else-if="erreur" class="alert alert-danger" role="alert">
            <i class="ri-error-warning-line me-1"></i> {{ erreur }}
        </div>

        <div v-else-if="loaded && !devices.length" class="text-center py-6 text-defaulttextcolor/60">
            <i class="ri-smartphone-line text-2xl"></i>
            <p class="mb-0 mt-2">Aucun serveur en service pour le moment.</p>
        </div>

        <div v-else-if="loaded" class="table-responsive">
            <table class="table table-hover whitespace-nowrap min-w-full">
                <thead>
                    <tr>
                        <th class="text-start">Serveur</th>
                        <th class="text-start">Appareil</th>
                        <th class="text-start">Adresse IP</th>
                        <th class="text-start">Statut</th>
                        <th class="text-start">Connexion</th>
                        <th class="text-start">Déconnexion</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in devices" :key="i">
                        <td>
                            <span class="font-semibold">{{ d.serveur_nom || '-' }}</span>
                            <span class="block text-[0.72rem] text-defaulttextcolor/50 font-mono">{{ d.serveur_pid.slice(0, 20) + "..." }}</span>
                        </td>
                        <td>{{ d.device_nom || '-' }}</td>
                        <td class="font-mono text-[0.8rem]">{{ d.ip || '-' }}</td>
                        <td>
                            <span class="badge" :class="d.statut === 'connecte'
                                ? 'bg-success/10 text-success'
                                : (d.statut === 'deconnecte' ? 'bg-danger/10 text-danger' : 'bg-warning/10 text-warning')">
                                <i class="ri-circle-fill text-[0.5rem] me-1"></i>
                                {{ libelleStatut(d.statut) }}
                            </span>
                        </td>
                        <td class="text-[0.8rem]">{{ formatDateTime(d.connecte_at) }}</td>
                        <td class="text-[0.8rem]">{{ formatDateTime(d.deconnecte_at) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
     const axios =require('axios');
    import * as JwtService from "@/common/jwt.service";
    import { randomString } from "@/allfunction";

    /**
     * Onglet Paramètres - présence des serveurs restaurant (Scan & Go).
     *
     * Lit la route PROTÉGÉE scango serveurdevices (btkpid de la session). Les
     * données viennent de scango_serveur_devices, alimentée à la prise de service
     * (quota) et au handshake/déconnexion socket. Purge quotidienne à 9h (cron).
     */
    export default {
        name: "serveurdevices",
        data: () => ({
            loading: false,
            loaded: false,
            erreur: "",
            devices: [],
            used: 0,
        }),
        methods: {
            _headers() {
                return {
                    "X-Requested-With": "XMLHttpRequest",
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + JwtService.getToken(),
                    "csrftoken": this.$store.state.appsociete,
                };
            },

            libelleStatut(s) {
                if (s === "connecte") return "En ligne";
                if (s === "deconnecte") return "Hors ligne";
                return "Enrôlé";
            },

            formatDateTime(v) {
                if (!v) return "-";
                const d = new Date(v);
                if (isNaN(d.getTime())) return String(v);
                const p = (n) => String(n).padStart(2, "0");
                return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
            },

            async charger() {
                this.loading = true;
                this.erreur = "";
                const url = process.env.VUE_APP_API_URL
                    + "/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/serveurdevices/"
                    + randomString();
                try {
                    const response = await axios.post(url, {}, { headers: this._headers(), withCredentials: true });
                   
                    const d = response.data || {};
                    if (d.success && d.m) {
                        this.devices = Array.isArray(d.m.devices) ? d.m.devices : [];
                        this.used = Number(d.m.used) || this.devices.length;
                    } else {
                        this.erreur = "Accès refusé ou module Scan & Go non configuré.";
                    }
                    this.loaded = true;
                } catch (e) {
                    console.error("[serveurdevices] chargement:", e);
                    this.erreur = "Impossible de charger la liste des appareils serveurs.";
                    this.loaded = true;
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>

<style scoped>
    .sd-wrap { padding: 0.25rem; }
</style>
